__webpack_require__.p = "/mustafakendiguzel-portfolio/";